import { render, staticRenderFns } from "./UjianTrialList.vue?vue&type=template&id=169fe75c&scoped=true"
import script from "./UjianTrialList.vue?vue&type=script&lang=js"
export * from "./UjianTrialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169fe75c",
  null
  
)

export default component.exports